<template>
  <div class="ele-body" >
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search" @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.type" placeholder="请选择">
                <el-option label="代收" value="1"> </el-option>
                <el-option label="代付" value="2"> </el-option>
                <el-option label="冻结" value="3"> </el-option>
                <el-option label="解冻" value="4"> </el-option>
                <el-option label="增加" value="5"> </el-option>
                <el-option label="减少" value="6"> </el-option>
                <el-option label="撤销" value="7"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="10" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker v-model="where.time" type="daterange" range-separator="～" start-placeholder="开始日期"
                value-format="yyyy-MM-dd" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload"
                >查询
              </el-button>
              <el-button @click="reset" >重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" @click="onExportClick"
                >导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
      </ele-pro-table>
    </el-card>

    <export-progress-dialog ref="exportDialog" biz="records" title="导出资金变动" />
  </div>
</template>

<script>
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';

export default {
  name: 'Records',
  components: { ExportProgressDialog },
  data() {
    return {
      // 表格数据接口
      url: '/UserBalancesRecords/getListIn',
      // 表格列配置
      columns: [
        {
          prop: 'id',
          label: 'ID',
          width: 60,
          align: 'center',
          showOverflowTooltip: true,
          fixed: "left"
        },
        {
          prop: 'merchantOrderNo',
          label: '用户订单',
          showOverflowTooltip: true,
          minWidth: 200,
          align: 'center',
        },
        {
          prop: 'order_no',
          label: '系统订单',
          showOverflowTooltip: true,
          minWidth: 200,
          align: 'center',
        },
        {
          prop: 'type',
          label: '类型',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'before_money',
          label: '变动前',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'money',
          label: '变动金额',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'after_money',
          label: '余额',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'remark',
          label: '内容',
          showOverflowTooltip: true,
          minWidth: 400,
          align: 'left',
        },

        {
          prop: 'update_time',
          label: '变动时间',
          showOverflowTooltip: true,
          minWidth: 200,
          align: 'center',
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          }
        }
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
    };
  },
  methods: {
    /* 刷新表格 */
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.reload();
    },
    onExportClick() {
      this.$refs.exportDialog.start({ ...this.where });
    }
  }
}
</script>

<style>
.el-form-item label {
  font-weight: bold;
  font-size: 16px;
}
</style>
